export default __webpack_public_path__ + "static/banner-vid-pure-plank-1eb6a42b9777aeba0a6d30ca05f22951.mp4";